module.exports = __webpack_public_path__ + "static/media/7.0cf706a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/mouth/7.png
// module id = 1376
// module chunks = 0